import './styles.css';
import { Table, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { useState } from 'react';
import InstallmentBanks from './components/InstallmentBanks';

const MobileInstallmentBanks = () => {
  const [activeTab, setActiveTab] = useState('0');

  return (
    <>
      <section className="bankIntrest">
        <div className="container">
          <InstallmentBanks />
        </div>
      </section>
      <section>
        <div className="container">
          <h2>How It Work</h2>
        </div>
      </section>
      <section className="step-1">
        <div className="container">
          <img alt="Card cap" src="img/step1.png" width="100%" />
          {/* <img src="img/step1.png" alt="Step 1" width="100%"> */}
          <div className="stepDescription">
            <span>01</span>
            <p>
              The installment eligibility message will display, if your
              selection is worth 999AED
            </p>
          </div>
        </div>
      </section>

      <section className="step-2">
        <div className="container">
          <img alt="Card cap" src="img/step2.png" width="100%" />
          <div className="stepDescription">
            <span>02</span>
            <p>
              {' '}
              If your total cart value is above 999, you will see the option to
              convert it into installments
            </p>
          </div>
        </div>
      </section>

      <section className="step-3">
        <div className="container">
          <img alt="Card cap" src="img/step3.png" width="100%" />
          <div className="stepDescription">
            <span>03</span>
            <p>
              Add a new card or choose an existing card from a bank that offers
              easy installment plans at checkout
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
export default MobileInstallmentBanks;
